import { getPhoneFormEmptyValues } from "../FormPartialPhoneNumber";
import { FormPartialDataPerson } from "./index";

export const getPersonFormEmptyValues = (
  country?: string
): FormPartialDataPerson => ({
  firstName: "",
  middleName: "",
  lastName: "",
  ownershipStake: 100,
  representativeConfirmation: false,
  jobTitle: "",
  birthday: null,
  email: "",
  phone: getPhoneFormEmptyValues(country),
  taxId: "",
  country: "US",
  address: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: ""
  }
});
